export default __webpack_public_path__ + "static/media/format-text.28c6430b.svg";